(() => {
  const key = 'raRyzoLauncherSessionV1';
  const state = { closed: false, position: null };
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (saved && typeof saved === 'object') {
      state.closed = saved.closed === true;
      if (saved.position && Number.isFinite(saved.position.x) && Number.isFinite(saved.position.y)) {
        state.position = saved.position;
      }
    }
  } catch (_) {}
  const persist = () => {
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) {}
  };
  const frame = () => ({
    width: document.documentElement.clientWidth,
    height: window.innerHeight
  });
  const clamp = (n, low, high) => Math.max(low, Math.min(n, Math.max(low, high)));
  const put = (container, point) => {
    const view = frame();
    const x = clamp(point.x, 10, view.width - 59);
    const y = clamp(point.y, 20, view.height - 54);
    container.style.setProperty('left', x + 'px', 'important');
    container.style.setProperty('top', y + 'px', 'important');
    container.style.setProperty('right', 'auto', 'important');
    container.style.setProperty('bottom', 'auto', 'important');
    return { x, y };
  };
  const initialPosition = () => {
    const view = frame();
    const arrow = document.getElementById('scroll-to-top-button');
    let right = 19;
    let bottom = view.width < 768 ? 200 : 162;
    if (arrow) {
      const css = getComputedStyle(arrow);
      const arrowRight = parseFloat(css.right);
      const arrowBottom = parseFloat(css.bottom);
      if (Number.isFinite(arrowRight)) right = arrowRight + (arrow.offsetWidth - 40) / 2;
      if (Number.isFinite(arrowBottom)) bottom = arrowBottom + (arrow.offsetHeight || 40) + 20;
    }
    return { x: view.width - 40 - right, y: view.height - 40 - bottom };
  };
  const position = (container) => {
    const view = frame();
    if (state.position) {
      put(container, {
        x: state.position.x * view.width,
        y: state.position.y * view.height
      });
    } else {
      put(container, initialPosition());
    }
  };
  const remember = (point) => {
    const view = frame();
    state.position = { x: point.x / view.width, y: point.y / view.height };
    persist();
  };
  const chatRoots = new WeakSet();
  const chatButtons = new WeakSet();
  const chatResize = new ResizeObserver(() => schedule());
  const syncFloatingControls = () => {
    const arrow = document.getElementById('scroll-to-top-button');
    const host = document.querySelector('shopify-chat');
    const root = host && host.shadowRoot;
    const runtime = root && root.querySelector('shopify-agent-runtime');
    const roots = [root, runtime && runtime.shadowRoot].filter(Boolean);
    roots.forEach((chatRoot) => {
      if (chatRoots.has(chatRoot)) return;
      chatRoots.add(chatRoot);
      new MutationObserver(schedule).observe(chatRoot, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
      new MutationObserver(schedule).observe(chatRoot.host, {
        attributes: true, attributeFilter: ['style', 'class']
      });
    });
    const chat = roots.map((chatRoot) => chatRoot.querySelector('[part~="activator"]')).find(Boolean);
    if (chat && !chatButtons.has(chat)) {
      chatButtons.add(chat);
      chatResize.observe(chat);
    }
    if (!arrow) return;
    const view = frame();
    let bottom = view.width < 768 ? 140 : 96;
    if (chat) {
      const rect = chat.getBoundingClientRect();
      const css = getComputedStyle(chat);
      if (rect.width && rect.height && css.visibility !== 'hidden' && css.display !== 'none') {
        bottom = Math.max(bottom, view.height - rect.top + 20);
      }
    }
    const value = Math.ceil(bottom) + 'px';
    if (arrow.style.getPropertyValue('--ra-floating-arrow-bottom') !== value) {
      arrow.style.setProperty('--ra-floating-arrow-bottom', value);
    }
    const container = document.querySelector('.ra-ryzo-launcher');
    if (container && !state.position && container.dataset.raDragging !== 'true') position(container);
  };
  const setup = () => {
    syncFloatingControls();
    const button = document.getElementById('float-image-icon');
    if (!button || !button.parentElement.classList.contains('ryzo-image-search-container')) return;
    const container = button.parentElement;
    if (button.dataset.raLauncherBound === 'true') return;
    button.dataset.raLauncherBound = 'true';
    container.classList.add('ra-ryzo-launcher');
    container.dataset.raState = state.closed ? 'closed' : 'ready';
    const italian = (document.documentElement.lang || 'it').toLowerCase().startsWith('it');
    button.setAttribute('aria-label', italian ? 'Cerca un prodotto con una foto' : 'Search products with a photo');
    button.setAttribute('title', italian ? 'Cerca con una foto. Trascina per spostare; da tastiera usa le frecce.' : 'Search with a photo. Drag to move; use arrow keys on the keyboard.');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'ra-ryzo-dismiss';
    close.textContent = '×';
    close.setAttribute('aria-label', italian ? 'Nascondi ricerca per immagini per questa sessione' : 'Hide image search for this session');
    close.setAttribute('title', italian ? 'Nascondi fino alla prossima sessione' : 'Hide until your next session');
    close.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      state.closed = true;
      persist();
      container.dataset.raState = 'closed';
    });
    container.appendChild(close);
    position(container);
    let drag = null;
    let suppressUntil = 0;
    button.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.button !== 0) return;
      const rect = container.getBoundingClientRect();
      suppressUntil = 0;
      drag = { id: event.pointerId, clientX: event.clientX, clientY: event.clientY, x: rect.x, y: rect.y, moved: false };
      try { button.setPointerCapture(event.pointerId); } catch (_) {}
    });
    button.addEventListener('pointermove', (event) => {
      if (!drag || drag.id !== event.pointerId) return;
      const dx = event.clientX - drag.clientX;
      const dy = event.clientY - drag.clientY;
      if (!drag.moved && Math.hypot(dx, dy) < 6) return;
      drag.moved = true;
      container.dataset.raDragging = 'true';
      event.preventDefault();
      put(container, { x: drag.x + dx, y: drag.y + dy });
    }, { passive: false });
    const finish = (event) => {
      if (!drag || drag.id !== event.pointerId) return;
      if (drag.moved) {
        suppressUntil = performance.now() + 500;
        const rect = container.getBoundingClientRect();
        remember({ x: rect.x, y: rect.y });
      }
      drag = null;
      delete container.dataset.raDragging;
    };
    button.addEventListener('pointerup', finish);
    button.addEventListener('pointercancel', finish);
    button.addEventListener('click', (event) => {
      if (performance.now() < suppressUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    button.addEventListener('keydown', (event) => {
      const directions = { ArrowLeft: [-1,0], ArrowRight: [1,0], ArrowUp: [0,-1], ArrowDown: [0,1] };
      const delta = directions[event.key];
      if (!delta) return;
      event.preventDefault();
      event.stopPropagation();
      const rect = container.getBoundingClientRect();
      const step = event.shiftKey ? 24 : 8;
      remember(put(container, { x: rect.x + delta[0] * step, y: rect.y + delta[1] * step }));
    });
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; setup(); });
  };
  setup();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', () => {
    syncFloatingControls();
    const container = document.querySelector('.ra-ryzo-launcher');
    if (container) position(container);
  }, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, { passive: true });
    window.visualViewport.addEventListener('scroll', schedule, { passive: true });
  }
  window.addEventListener('pageshow', () => {
    syncFloatingControls();
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && typeof saved === 'object') {
        state.closed = saved.closed === true;
        if (saved.position && Number.isFinite(saved.position.x) && Number.isFinite(saved.position.y)) state.position = saved.position;
      }
    } catch (_) {}
    const container = document.querySelector('.ra-ryzo-launcher');
    if (container) {
      container.dataset.raState = state.closed ? 'closed' : 'ready';
      position(container);
    }
  });
})();
